import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import Footer from "../inc/Footer";
import { path } from "../../../utils";

import "./PrivacyPolicy.scss";
import Header from "../inc/Header";
class PrivacyPolicy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadingPreloader: true,
      isCartOpen: false,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ isLoadingPreloader: false });
    }, 500);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {}

  handleToggleCart = () => {
    this.setState((prevState) => ({
      isCartOpen: !prevState.isCartOpen,
    }));
  };

  render() {
    let { language } = this.props;
    return (
      <>
        {/* <Header /> */}
        <Header />
        {language === "vi" ? (
          <div className="container privacy">
            <div className="intro">
              <h2>CHÍNH SÁCH & ĐIỀU KHOẢN DỊCH VỤ</h2>
              <p>Áp dụng cho tất cả khách hàng tại Việt Nam</p>
              <p>
                Công ty TNHH Hải Phước - Nhà phân phối chính thức thiết bị phân
                tích cơ thể Anovator A5
              </p>
            </div>
            <section>
              <h2>1. CHÍNH SÁCH QUYỀN RIÊNG TƯ</h2>

              <h3>📌 Cam kết bảo mật thông tin cá nhân</h3>
              <p>
                Chúng tôi tôn trọng quyền riêng tư và bảo vệ toàn diện dữ liệu
                của bạn. Khi bạn mua hàng hoặc liên hệ với chúng tôi, các thông
                tin bạn cung cấp được bảo mật tuyệt đối.
              </p>

              <h4>✅ Chúng tôi thu thập:</h4>
              <ul>
                <li>Họ tên, email, số điện thoại, địa chỉ nhận hàng</li>
                <li>Thông tin liên quan đến đơn hàng và hỗ trợ kỹ thuật</li>
                <li>
                  Hành vi truy cập website nhằm cải thiện trải nghiệm người dùng
                </li>
              </ul>

              <h4>🎯 Mục đích sử dụng:</h4>
              <ul>
                <li>Xử lý đơn hàng & giao hàng nhanh chóng</li>
                <li>Hỗ trợ kỹ thuật & chăm sóc khách hàng sau bán</li>
                <li>Gửi thông báo, chương trình ưu đãi khi có sự đồng ý</li>
                <li>Cải tiến dịch vụ & ngăn ngừa gian lận</li>
              </ul>

              <h4>🛡️ Bảo mật dữ liệu:</h4>
              <ul>
                <li>Lưu trữ bằng công nghệ mã hóa tiêu chuẩn quốc tế</li>
                <li>
                  Không chia sẻ với bên thứ ba ngoại trừ đối tác vận chuyển hoặc
                  khi có yêu cầu pháp lý
                </li>
                <li>
                  Bạn có quyền chỉnh sửa hoặc yêu cầu xóa thông tin bất cứ lúc
                  nào
                </li>
              </ul>
            </section>
            <div className="contact-info support">
              <h2>THÔNG TIN LIÊN HỆ HỖ TRỢ</h2>
              <p>
                Công ty TNHH Hải Phước – Nhà phân phối Anovator chính thức tại
                Việt Nam
              </p>
              <p>
                <strong>Website:</strong>{" "}
                <a
                  href="https://www.anovator.vn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.anovator.vn
                </a>
              </p>
              <p>
                <strong>Điện thoại:</strong> 0359.951.5131 (Phước)
              </p>
              <p>
                <strong>Email:</strong> support@anovator.vn
              </p>
              <p>
                <strong>Văn Phòng Chính - Top Fitness Center:</strong>
                <br />
                227 - 229 Hà Huy Giáp, Phường Thạnh Lộc, Quận 12
              </p>
            </div>
          </div>
        ) : (
          <div className="container privacy">
            <div className="intro">
              <h2>POLICIES & TERMS OF SERVICE</h2>
              <p>Applicable to all customers in Vietnam</p>
              <p>
                Hai Phuoc Co., Ltd - Official Distributor of Anovator A5 Body
                Composition Analyzer
              </p>
            </div>
            <section>
              <h2>1. PRIVACY POLICY</h2>

              <h3>🔒 Commitment to Data Privacy</h3>
              <p>
                We respect your privacy and are fully committed to protecting
                your personal data. All information you provide when purchasing
                or contacting us is kept strictly confidential.
              </p>

              <h4>✅ Data We Collect:</h4>
              <ul>
                <li>Full name, email, phone number, shipping address</li>
                <li>Order details and technical support information</li>
                <li>Website usage behavior to improve user experience</li>
              </ul>

              <h4>🎯 Purpose of Data Use:</h4>
              <ul>
                <li>Process orders and ensure fast delivery</li>
                <li>Provide technical and post-sale customer support</li>
                <li>Send updates, promotions (with your consent)</li>
                <li>Improve services and prevent fraud</li>
              </ul>

              <h4>🛡️ Data Security:</h4>
              <ul>
                <li>Stored with industry-standard encryption technologies</li>
                <li>
                  Not shared with third parties unless required for delivery or
                  by law
                </li>
                <li>
                  You have the right to edit or request deletion of your
                  information at any time
                </li>
              </ul>
            </section>
            <div className="contact-info support">
              <h2>SUPPORT CONTACT INFORMATION</h2>
              <p>
                Hai Phuoc Co., Ltd – Official Distributor of Anovator in Vietnam
              </p>
              <p>
                <strong>Website:</strong>{" "}
                <a
                  href="https://www.anovator.vn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.anovator.vn
                </a>
              </p>
              <p>
                <strong>Phone:</strong> 0989.499.889
              </p>
              <p>
                <strong>Email:</strong> support@anovator.vn
              </p>
              <p>
                <strong>Head Office – Top Fitness Center:</strong>
                <br />
                227 – 229 Ha Huy Giap Street, Thanh Loc Ward, District 12
              </p>
            </div>
          </div>
        )}

        <Footer />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return { language: state.app.language };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PrivacyPolicy)
);
